import { PAYMENT_STATUS } from 'config/environments/shared';
import { pluralize } from 'helpers';

type TagVariants = 'disabled' | 'success' | 'alert' | 'error';

type PaymentStatus = { [key: string]: { [key: string]: PaymentStatusVariants } };

type TagStatus = 'Pago' | 'Em atraso' | 'Em aberto' | 'Vencido';

export type PaymentStatusVariants = {
  subTitle?: string;
  tag: TagStatus;
  tagVariant: TagVariants;
  toolTip?: string;
};

export const getPaymentStatus = ({
  daysLate,
  daysUntilDueDate,
  paymentStatus,
  status,
}: {
  daysLate: number;
  daysUntilDueDate: number;
  paymentStatus: string;
  status: string;
}): PaymentStatusVariants | undefined => {
  const daysLateLabel = pluralize(daysLate, `Venceu ontem`, `Venceu há ${daysLate} dias`);
  const moreThanZeroDaysLeft = daysUntilDueDate > 0;

  const paid = {
    tag: 'Pago',
    tagVariant: 'success' as TagVariants,
  };

  const expired = {
    tagVariant: 'error',
    tag: 'Vencido',
    subTitle: daysLateLabel,
    toolTip:
      'O pagamento do título vencido pode ser renegociado no Portal de Renegociação, WhatsApp ou Central de Atendimento.',
  };

  const variants: PaymentStatus = {
    closed: {
      overdue: {
        tag: 'Pago',
        tagVariant: 'success',
      },
      notOverdue: {
        tag: 'Pago',
        tagVariant: 'success',
      },
    },
    open: {
      overdue: {
        tagVariant: 'alert',
        tag: 'Em atraso',
        subTitle: daysLateLabel,
        toolTip:
          'O pagamento do título atrasado pode ser feito com o mesmo documento ou código de barras. Se houver juros, serão calculados e aplicados na hora do pagamento.',
      },
      notOverdue: {
        tagVariant: 'disabled',
        tag: 'Em aberto',
        subTitle: moreThanZeroDaysLeft
          ? daysUntilDueDate === 1
            ? 'Vence amanhã'
            : `Vence em ${daysUntilDueDate} dias`
          : 'Vence hoje',
        toolTip: 'Após o pagamento, a atualização do status pode levar até 2 dias úteis.',
      },
    },
  };

  if (status === PAYMENT_STATUS.EXPIRED) {
    return expired as PaymentStatusVariants;
  }

  if (paymentStatus === PAYMENT_STATUS.PAID) {
    return paid as PaymentStatusVariants;
  }

  if (!variants[paymentStatus]) {
    return;
  }

  return variants[paymentStatus][status];
};
